/**
 * Status eines Client
 */
export enum ClientStatus {
   /**
    * Client angelegt und bestätigt.
    */
   active = "active",

   /**
    * Client alt und aussortiert.
    */
   old = "old",

   /**
    * Client vom Kunden gelöscht.
    */
   deleted = "deleted",
}

export const ClientStatusNames = {
   active: "Aktuell",
   old: "Alt",
   deleted: "Gelöscht von Kund:in"
};